import React, { useState, useEffect } from 'react';
import { FiMessageSquare } from 'react-icons/fi';
import WhatsAppTemplateSelector from '../../WhatsAppTemplateSelector';
import apiClient from '../../../apiClient';
import ActionButton from '../ActionButton/ActionButton';
// import './WhatsAppButton.css';

const WhatsAppButton = ({ phone }) => {
  const [showSelector, setShowSelector] = useState(false);
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await apiClient.get('/api/wptemplates');
        setTemplates(response.data);
      } catch (error) {
        console.error('Failed to fetch WhatsApp templates:', error);
      }
    };
    fetchTemplates();
  }, []);

  const openWhatsAppWithTemplate = (templateContent) => {
    const phoneNumber = phone.replace(/[^0-9]/g, ''); // sanitize phone number
    const encodedMessage = encodeURIComponent(templateContent);
    const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(url, '_blank');
    setShowSelector(false);
  };

  if (!phone) return null;

  return (
    <>
      <ActionButton
        icon={FiMessageSquare}
        onClick={(e) => {
          e.stopPropagation();
          setShowSelector(true);
        }}
        className="whatsapp-btn"
        title="Send WhatsApp message"
      />
      {showSelector && (
        <WhatsAppTemplateSelector 
          templates={templates} 
          onSelect={openWhatsAppWithTemplate} 
          onClose={() => setShowSelector(false)} 
        />
      )}
    </>
  );
};

export default WhatsAppButton;
